import { ChevronIcon } from '@/assets/icons/ChevronIcon';
import styles from '../../NavHeaderComponents/drawer.module.scss';

export interface NavDropdownItemProps {
    label: string;
    selectItem: () => void;
}

export function NavDropdownItemMobile({ label, selectItem }: NavDropdownItemProps) {
    return (
        <button className={styles.mobileSupportButton} onClick={() => selectItem()} aria-label={label}>
            <span>{label}</span>
            <span className={styles.chevronIconWrapper}>
                <ChevronIcon direction="right" />
            </span>
        </button>
    );
}
